import React, { FunctionComponent, PropsWithChildren } from 'react'
import style from './infoButton.css'

export type Props = PropsWithChildren<{
    openModal: Function
    dataTestId: string
}>

const InfoButton: FunctionComponent<Props> = (props) => {
    const {
        openModal,
        children,
        dataTestId,
    } = props

    return (
        <button onClick={() => openModal()} className={style.button} type="button" data-testid={dataTestId}>
            {children}
        </button>
    )
}

export default InfoButton
